import React, { Component, ErrorInfo, ReactNode } from 'react'
import './ApplyV2ErrorBoundary.scss'

const baseClass = 'ApplyV2ErrorBoundary'

interface Props {
    children: ReactNode
}

interface State {
    hasError: boolean
}

class ApplyV2ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
    }

    public static getDerivedStateFromError(): State {
        return { hasError: true }
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('ApplyV2 Error:', error, errorInfo)
    }

    public render() {
        if (this.state.hasError) {
            return (
                <div
                    className={baseClass}
                    style={{
                        padding: '40px 20px',
                        textAlign: 'center',
                        backgroundColor: '#f8f9fa',
                        border: '1px solid #dee2e6',
                        borderRadius: '8px',
                        margin: '20px',
                    }}
                >
                    <h3 style={{ color: '#dc3545' }}>Error</h3>
                    <p style={{ margin: '15px 0' }}>Something went wrong. Please try again later.</p>
                    <button
                        onClick={() => {
                            localStorage.clear()
                            window.location.reload()
                        }}
                        style={{
                            padding: '10px 20px',
                            backgroundColor: '#007bff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                        }}
                    >
                        Reload the page
                    </button>
                </div>
            )
        }

        return this.props.children
    }
}

export default ApplyV2ErrorBoundary
